// extracted by mini-css-extract-plugin
export default {"slider":"slider_slider__nXnhM","item":"slider_item__IpaR+","active":"slider_active__Gr0Dx","opacity-transition":"slider_opacity-transition__RP5j7"};